import React, { useEffect } from "react"
import { Container, Typography, Box } from '@material-ui/core';
import { Create_Work_From } from "./../components/Create_Work_From/form"

const Create_Work = (props) => {
    useEffect(() => {
        document.title = `Com7 Merchandise - หน้าสำหรับสร้างงาน`
    }, [])
    return (<React.Fragment>
        <Container style={{ paddingLeft: '0', paddingRight: '0', paddingTop: '2rem' }}>
            <Typography component="div" style={{ backgroundColor: 'white', borderRadius: '10px' }}>
                <Container style={{ marginTop: '10px', height: '10%', }}>
                    <Typography variant="h4" style={{ fontWeight: 'bold' }}> Create Work</Typography>
                </Container>
                <Container style={{ display: 'flex', padding: '0px 25px', height: '90%' }}>
                    <Box color="primary.main">
                        <Create_Work_From />
                    </Box>
                </Container>
            </Typography>
        </Container>
    </React.Fragment>)
}
export default Create_Work